import * as IncidentsConstants from './IncidentsConstants';
import AppService from 'Global/AppService';

export const addDeviceToIncidentReducerState = (instanceId) => {
	return {
		type: IncidentsConstants.INCIDENTS_DATA_STATE_ADD,
		payload: instanceId
	}
};

export const removeDeviceToIncidentReducerState = (instanceId) => {
	return {
		type: IncidentsConstants.INCIDENTS_DATA_STATE_REMOVE,
		payload: instanceId
	}
};


export const getIncidentsData = (url, payload, deviceId, pageConfig, fetchNext) => {
	
	return (dispatch) => {
		dispatch({ type: IncidentsConstants.INCIDENTS_DATA_FETCHING, payload: { deviceId, pageConfig, fetchNext } });

		function callback(success, err) {
			
			if (success && success.result) {
				dispatch(getIncidentsDataSuccess(success, deviceId, pageConfig.pageSize, fetchNext));
			} else {
				dispatch(getIncidentsDataFailure(deviceId));
			}
		}

		AppService.postData(payload, url, callback);
	}
}

const getIncidentsDataSuccess = (successResponse, deviceId, requestedPageSize, fetchNext) => {
	return { type: IncidentsConstants.INCIDENTS_DATA_FETCHED, payload: { newState: successResponse, deviceId, requestedPageSize, fetchNext } };
}

const getIncidentsDataFailure = (deviceId) => {
	return { type: IncidentsConstants.INCIDENTS_DATA_FETCHING_FAILED,payload:deviceId };
}
